import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqs: FAQItem[] = [
  {
    question: 'po文学是什么意思？和传统网络文学有什么不同？',
    answer: 'po文学是近年来兴起的一种新型网络文学形式，全称为"post文学"。与传统网络文学动辄数十万字的体量不同，po文学以短小精悍的篇幅、碎片化的叙事方式和强烈的情绪共鸣为核心特征。它更注重瞬间情感的捕捉和表达，而非构建完整的故事情节。可以说，po文学是碎片化阅读时代的产物，更加符合当代人的阅读习惯。',
  },
  {
    question: '完全没有写作基础，可以学习po文学创作吗？',
    answer: '当然可以！po文学的一个重要特点就是创作门槛低。因为它不要求构建复杂的情节线和人物关系，你可以从记录生活中的一个瞬间、一种情绪开始。许多优秀的po文创作者最初都没有专业的写作背景。建议从模仿优秀作品开始，逐步找到属于自己的风格和表达方式。',
  },
  {
    question: 'po文学有哪些主流的创作风格？',
    answer: '目前po文学领域主要有四大风格流派：清冷文艺风（克制、疏离、诗意）、热烈叙事风（浓烈、直接、充满张力）、暗黑悬疑风（神秘、紧张、引人入胜）和温暖治愈风（温柔、治愈、充满希望）。每种风格都有其独特的语言特征和情感基调，创作者可以根据自己的性格和表达偏好选择适合自己的方向。',
  },
  {
    question: '写po文需要多长时间？每天都要更新吗？',
    answer: 'po文学的篇幅通常较短，一篇作品的创作时间从几十分钟到几小时不等，相比传统长篇创作大大缩短。关于更新频率，建议新手从每周2-3篇开始，建立稳定的创作习惯。质量比数量更重要——一篇精心打磨的po文，比十篇仓促完成的更能打动读者。',
  },
  {
    question: 'po文学作品可以在哪些平台发布？',
    answer: '目前主流的po文发布平台包括小红书、微博超话、豆瓣小组和LOFTER等。不同平台的用户群体和内容偏好有所差异：小红书女性用户为主，偏好文艺治愈风；微博传播速度快；豆瓣评论氛围浓厚；LOFTER同人文化丰富。建议新手从1-2个平台起步。',
  },
  {
    question: 'po文学能赚钱吗？有哪些变现方式？',
    answer: '随着po文学的产业化发展，已经形成了多元化的变现模式。常见方式包括：付费阅读内容、品牌商业合作、IP授权（改编为短视频/音频/漫画等）、线下创作分享活动、创作培训课程等。但需要注意的是，商业变现是创作能力的自然延伸——先把内容做好，变现自然会随之而来。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-800 text-xs font-medium mb-4">
            常见问题
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            关于po文学，你想知道的都在这里
          </h2>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl border border-background-200/60 bg-background-100 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-200/30 transition-colors"
              >
                <span className="font-heading font-semibold text-foreground-900 text-sm pr-4">
                  {faq.question}
                </span>
                <div className={`w-6 h-6 flex-shrink-0 flex items-center justify-center transition-transform duration-300 ${openIndex === index ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line text-foreground-500"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <p className="px-5 pb-4 text-foreground-600 text-sm leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}